import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes, volumeIncludes, coverage } from '../data/volumes';
const stats = [{
  value: '280+',
  label: 'Pages'
}, {
  value: '150+',
  label: 'Drills'
}, {
  value: '12',
  label: 'Volumes'
}, {
  value: 'All',
  label: 'Levels'
}];
export function SystemOverview() {
  return <section className="w-full bg-court-950 py-20 text-white" aria-labelledby="system-title" data-id="element-205" data-mp="1hovrpt8j4rhf">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-206" data-mp="tyrq1rewj1t2">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ball" data-id="element-207" data-mp="pwentczd5m11">
          🏆 The most complete system for tennis coaches worldwide
        </p>
        <div className="mt-6 grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-end" data-id="element-208" data-mp="13xhbfu60b4e2">
          <div data-id="element-209" data-mp="ywbgrqssd71w">
            <h2 id="system-title" className="font-display text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl" data-id="element-210" data-mp="yvrvc03xg0j4">
              TENNIS 360™
              <span className="mt-2 block text-ball" data-id="element-211" data-mp="2abq9ujhvjerq">12 Volumes + 6 Bonuses</span>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-court-600" data-id="element-212" data-mp="2364a4sls7ac3">
            Over 280 pages of ready-to-use sessions, professional drills, level progressions,
            planning tools and student management —{' '}
            <span className="font-semibold text-white" data-id="element-213" data-mp="2d2pldvoe9hod">all done for you.</span>
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-2xl bg-court-800 sm:grid-cols-4" data-id="element-214" data-mp="1kfwfz0027u81">
          {stats.map(stat => <div key={stat.label} className="bg-court-900 px-4 py-6 text-center" data-id="element-215" data-mp="1pfr4wy09y9qg">
              <p className="font-display text-3xl font-black text-ball" data-id="element-216" data-mp="1udslnca89wyr">{stat.value}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.16em] text-court-600" data-id="element-217" data-mp="1z5aqibfdghp0">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-16" data-id="element-218" data-mp="16ohummiojgxt">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-court-600" data-id="element-219" data-mp="16ng73ikh91z7">
            Full coverage · Every level & age group
          </p>
          <ul className="mt-5 flex flex-wrap gap-2" data-id="element-220" data-mp="top6kvu4aovj">
            {coverage.map(item => <li key={item} className="rounded-full border border-court-800 bg-court-900 px-4 py-2 text-sm text-white" data-id="element-221" data-mp="tmutu4t0232j">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-20" data-id="element-222" data-mp="fpzbtmurt1ac">
          <h3 className="font-display text-2xl font-black tracking-tight sm:text-3xl" data-id="element-223" data-mp="fr0lbmw51fpy">
            The 12 Complete Volumes
          </h3>
          <ol className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-224" data-mp="pnn5e9gn42qx">
            {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col rounded-2xl border border-court-800 bg-court-900 p-6 transition-[border-color,transform] duration-200 ease-smooth hover:-translate-y-0.5 hover:border-ball/50" data-id="element-225" data-mp="knr96we6pflx">
                <div className="flex items-center gap-2.5" data-id="element-226" data-mp="23mynchau5e6e">
                  <span className="h-2.5 w-2.5 rounded-full" style={{
                backgroundColor: volume.dot
              }} aria-hidden="true" data-id="element-227" data-mp="23ldwb1nqcdda" />
                  <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-court-600" data-id="element-228" data-mp="1uo3ib8jj2a4o">
                    Volume {volume.number}
                  </span>
                </div>
                <h4 className="mt-3 font-display text-lg font-extrabold leading-snug tracking-tight" data-id="element-229" data-mp="2mdyiy1cu5m8n">
                  {volume.title}
                </h4>
                <p className="mt-2 text-sm leading-relaxed text-court-600" data-id="element-230" data-mp="2dlee2j5yalfd">{volume.subtitle}</p>
                <p className="mt-auto pt-5 text-xs leading-relaxed text-ball/80" data-id="element-231" data-mp="2hlyatlmm3n0z">
                  {volume.tags.join(' · ')}
                </p>
              </li>)}
          </ol>
        </div>

        <div className="mt-16 rounded-3xl border border-court-800 bg-court-900 p-8 sm:p-10" data-id="element-232" data-mp="3a30y92jzz2zz">
          <h3 className="font-display text-xl font-black uppercase tracking-tight sm:text-2xl" data-id="element-233" data-mp="1mez623hbodgr">
            What Every Volume Includes
          </h3>
          <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-234" data-mp="1he1p1u81tpgu">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm text-white" data-id="element-235" data-mp="1ci330da70jjl">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ball" strokeWidth={3} aria-hidden="true" data-id="element-236" data-mp="18grbg27rdo8r" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}